// Initial global state

export default {
  isLoading: false,
};
